<form>
    <rask-card
        label="{{ atgard.namn }} {{ atgard.beteckning }}"
        [size]="4"
        [ngClass]="{ hovering: atgard.isHovering }"
        (mouseover)="atgardService.hoverToggle(atgard, true)"
        (mouseleave)="atgardService.hoverToggle(atgard, false)"
    >
        <ng-container>
            <div class="row justify-content-between px-3">
                <rask-input
                    class="col-2"
                    label="Volym"
                    value="{{ atgard.volymAtgard }}"
                    [readonly]="true"
                ></rask-input>
                <rask-input
                    class="col-8"
                    label="Typ"
                    value="{{ atgard.atgardstyp }}"
                    [readonly]="true"
                ></rask-input>
            </div>
        </ng-container>
    </rask-card>
</form>
